import { isInDebug } from "./config";
import axios, { AxiosRequestConfig } from 'axios';
import { getTokenCache } from '../authentication/tokenCacheFactory';

export const getAuthInterceptor = () => async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    try {
        const finalConfig = { ...config };

        finalConfig.baseURL = isInDebug(config.baseURL, config.url);

        const token = await getTokenCache().getToken();

        if (token) {
            finalConfig.headers = {
                ...(finalConfig.headers || {}),
                Authorization: `Bearer ${token}`,
            };
        } else {
            console.warn("[AuthInterceptor] Nessun token disponibile per la richiesta", config.url);
        }

        return finalConfig;
    } catch (error) {
        console.error("[AuthInterceptor] Errore nell'interceptor:", error);
        return Promise.reject(error);
    }
};

// Applica l'interceptor ad axios
export const setupInterceptors = () => {
    axios.interceptors.request.use(getAuthInterceptor());
};